import Layout from '@layout/Index'

export const imgFlowModel = [
  {
    path: '/img-flow-model',
    component: Layout,
    children: [
      {
        path: '',
        redirect: 'table',
      },
      {
        path: 'table',
        component: () => import(/* webpackChunkName: "img-flow-model-table" */ './pages/ImgFlowModelTable.vue'),
        name: '图片流转模型列表',
        meta: {
          title: '图片流转模型列表',
        },
      },
      // {
      //   path: 'create',
      //   component: () => import(/* webpackChunkName: "img-flow-model-form" */ './pages/ImgFlowModelForm.vue'),
      //   name: '添加图片流转模型',
      // },
      // {
      //   path: 'update/:id',
      //   component: () => import(/* webpackChunkName: "img-flow-model-form" */ './pages/ImgFlowModelForm.vue'),
      //   name: '修改图片流转模型',
      // },
      // {
      //   path: 'detail/:id',
      //   component: () => import(/* webpackChunkName: "img-flow-model-detail" */ './pages/ImgFlowModelDetail.vue'),
      //   name: '图片流转模型详情',
      // },
    ],
  },
]



// WEBPACK FOOTER //
// ./src/views/img-flow-model/img-flow-model.route.js